import { render, staticRenderFns } from "./UserDirectory.vue?vue&type=template&id=529d46a1&style=display%3A%20flex"
import script from "./UserDirectory.vue?vue&type=script&lang=js"
export * from "./UserDirectory.vue?vue&type=script&lang=js"
import style0 from "./UserDirectory.vue?vue&type=style&index=0&id=529d46a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports